
import { Organization } from '@/types/organizationTypes';
import { useStripeAccountStatus } from './useStripeAccountStatus';
import { useStripeAccountOperations } from './useStripeAccountOperations';
import { useEffect } from 'react';

export const useStripeConnect = (
  organization: Organization | null, 
  organizationId: string | undefined
) => {
  const {
    loading: statusLoading,
    accountStatus,
    detailedStatus,
    fetchAccountStatus
  } = useStripeAccountStatus(organization);

  const {
    loading: operationsLoading,
    requestPending,
    errorMessage,
    platformSetupRequired,
    createConnectAccount,
    disconnectStripeAccount,
    checkPendingRequest
  } = useStripeAccountOperations(organization, organizationId);
  
  // Check for pending requests on initial load
  useEffect(() => {
    if (organizationId && accountStatus === 'none') {
      checkPendingRequest();
    }
  }, [organizationId, accountStatus, checkPendingRequest]);

  return {
    loading: statusLoading || operationsLoading,
    accountStatus,
    detailedStatus,
    errorMessage,
    requestPending,
    platformSetupRequired,
    createConnectAccount,
    disconnectStripeAccount
  };
};
